import { reactive } from 'vue';
import config from '../config.js';
import { decodeJwtPayload } from '../utils/jwt.js';

const SESSION_KEY = 'formpilot_session';

// Restore minimal session data on page load (no password stored)
const saved = (() => {
  try { return JSON.parse(sessionStorage.getItem(SESSION_KEY)); } catch { return null; }
})();

export const authStore = reactive({
  isLoggedIn: !!saved,
  currentUser: saved || null,

  async login(username, password) {
    try {
      const res = await fetch(`${config.authUrl}/v1/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });
      if (!res.ok) return false;

      const { token, expires_at, name } = await res.json();
      const groups = decodeJwtPayload(token)?.groups || [];
      this.isLoggedIn = true;
      this.currentUser = { username, name: name || username, token, expiresAt: expires_at * 1000, groups };
      sessionStorage.setItem(SESSION_KEY, JSON.stringify(this.currentUser));
      return true;
    } catch {
      return false;
    }
  },

  logout() {
    this.isLoggedIn = false;
    this.currentUser = null;
    sessionStorage.removeItem(SESSION_KEY);
  },

  getToken() {
    return this.currentUser?.token || null;
  },

  isSessionValid() {
    return this.isLoggedIn && !!this.currentUser?.token && this.currentUser.expiresAt > Date.now();
  },

  hasRole(role) {
    return !!this.currentUser?.groups?.includes(role);
  },
});
